<template>
    <skeleton-loader v-if="loading" type="assigned-detail" class="px-4" />
    <div v-else>
        <div class="cd-topbar">
            <back-button :route="backRoute" />
        </div>
        <pre-assigned-routine v-if="!hasPreAssignedRoutineData" @complete="onCompletePreAssignedRoutine"
            :assignedRoutineId="assignedRoutineId" :coach-id="coachId" :questionnaireId="questionnaireId"
            is-competence />
        <post-assigned-routine v-else @finish="onFinishAssignedRoutine" :assignedRoutineId="assignedRoutineId"
            :coach-id="coachId" ref="post" is-competence />
        <summary-assigned-routine-dialog :back-button="showBackBtn" @hide="onHideSummary"
            :assignedRoutineId="assignedRoutineId" ref="summary" is-competence />
    </div>
</template>

<script>

import { db } from "@/utils/Firebase";
import { mapMutations, mapState } from 'vuex'
import PreAssignedRoutine from "@/components/student/PreAssignedRoutine";
import PostAssignedRoutine from "@/components/student/PostAssignedRoutine";
import SummaryAssignedRoutineDialog from "@/components/student/SummaryAssignedRoutineDialog";
import SkeletonLoader from "@/components/common/SkeletonLoader";
import BackButton from "@/components/common/BackButton";

export default {
    components: {
        BackButton,
        SkeletonLoader,
        PreAssignedRoutine,
        PostAssignedRoutine,
        SummaryAssignedRoutineDialog,
    },
    data() {
        return {
            loading: false,
            assignedRoutine: null,
            showBackBtn: false,
        }
    },
    computed: {
        ...mapState(['currentRoutine']),
        assignedRoutineId(vm = this) {
            return vm.$route.params.uid
        },
        questionnaireId(vm = this) {
            return vm.assignedRoutine?.assignedQuestionnaireId || null
        },
        hasPreAssignedRoutineData(vm = this) {
            // return false
            return !!(vm.assignedRoutine?.advance?.pre)
        },
        hasPostAssignedRoutineData(vm = this) {
            // return true
            return !!(vm.assignedRoutine?.advance?.post)
        },
        fixedBackBtn(vm = this) {
            return vm.hasPreAssignedRoutineData
        },
        coachId(vm = this) {
            return vm.currentRoutine?.coachId || vm.assignedRoutine?.coachId || null
        },
        backRoute(vm = this) {
            let route = { name: 'student.routines' }
            let date = vm.currentRoutine?.rawDate?.full || vm.assignedRoutine?.rawDate?.full || null
            if (!date) return route
            route.query = { date: date }
            return route
        }
    },
    async mounted() {
        const vm = this
        await vm.loadAssignedRoutine()
        vm.applyTitle()
    },
    watch: {
        hasPreAssignedRoutineData() {
            this.applyTitle()
        }
    },
    methods: {
        ...mapMutations(['setCurrentRoutine', 'setTitle', 'setCurrentCarousel']),
        applyTitle() {
            const vm = this
            vm.setTitle(vm.hasPreAssignedRoutineData ? 'routines.last_step' : 'routines.before_start')
        },
        async loadAssignedRoutine() {
            const vm = this
            await vm.withLoading(async () => {
                let assignedRoutineRef = await db.collection('assignedRoutines').doc(vm.assignedRoutineId).get()
                vm.assignedRoutine = assignedRoutineRef.data()
                vm.setCurrentRoutine(vm.assignedRoutine)
            })
        },
        async onCompletePreAssignedRoutine() {
            const vm = this
            await vm.loadAssignedRoutine()
            vm.toast(vm.$t('routines.data_saved'))
        },
        onCompleteAssignedRoutine() {
            const vm = this
            if (!vm.hasPostAssignedRoutineData) vm.toast(vm.$t('routines.complete'))
            vm.loadAssignedRoutine()
        },
        onFinishAssignedRoutine() {
            const vm = this
            vm.$refs.summary.show()
        },
        onHideSummary() {
            const vm = this
            if (vm.$refs.post) vm.$refs.post.loadingContent = true
        },
        showSummary() {
            const vm = this
            vm.showBackBtn = true
            vm.$refs.summary.show()
        }
    },
    beforeRouteLeave(to, from, next) {
        const vm = this
        vm.setCurrentRoutine()
        vm.setCurrentCarousel()
        vm.setTitle()
        next()
    }
}
</script>
<style scoped>

.cd-topbar {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-top: 1px solid var(--v-outline-base);
    border-bottom: 1px solid var(--v-outline-base);
    margin-bottom: 12px;
}

</style>
